<template>
  <div ref="root" v-resize="debounceResize">
    <div ref="header">
      <slot name="header" />
    </div>
    <slot name="toolbar" />
    <slot name="filter" />
    <div ref="resizableDiv">
      <slot name="table" :body-height="bodyHeight" />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
export default {
  name: 'ResizablePage',
  props: {
    footerHeight: {
      type: Number,
      default: 59, //default v-data-table footer height
    },
    calcHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bodyHeight: 0,
      resizeObserver: null,
    };
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.debounceResize).observe(
      this.$refs.root
    );
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.root);
    }
  },
  created() {
    this.debounceResize = debounce(this.onResize, 1);
  },
  methods: {
    onResize() {
      if (!this.$refs.resizableDiv) {
        return;
      }
      this.bodyHeight =
        window.innerHeight -
        this.$refs.resizableDiv.getBoundingClientRect().y -
        this.footerHeight;
      if (this.calcHeader && this.$refs.header) {
        this.bodyHeight -= this.$refs.header.getBoundingClientRect().height;
      }
    },
  },
};
</script>
